import { useQuery } from "react-query";
import { getContentfulTags } from "src/services/contentfulClient";

export const useTags = () => {
  return useQuery(["contentful", "tags"], () => getContentfulTags());
};
